<section
  *ngIf="isRestaurant && warnings.length"
  class="rhp"
  [class.rhp--page]="!isDashboard"
  data-testid="restaurant-health"
>
  <div
    *ngFor="let warning of warnings"
    class="rhp__warning"
    [class.rhp__warning--danger]="warning.severity === 'danger'"
    role="alert"
    [attr.data-testid]="'restaurant-warning-' + warning.id"
  >
    <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
    <span class="rhp__message">{{ warning.messageKey | translate }}</span>
    <button type="button" class="rhp__fix" [disabled]="fixing === warning.id" (click)="fix(warning)">
      {{ warning.fixKey | translate }}
    </button>
  </div>
</section>
